import { flattenDeep as _flattenDeep } from 'lodash'

let files = []
const requireModule = require.context('@/routes', false, /\.js$/i, 'sync')
requireModule.keys().forEach(fileName => {
  if (['index.js', 'routes.js'].some(path => fileName.includes(path))) return

  files = [
    ...files,
    ...[requireModule(fileName).default]
  ]
})

export default _flattenDeep(files)
